import { Nullable } from "models/Nullable";
import { isEmpty } from "./isEmpty";

export function nullIfEmpty<T>(value: Nullable<T>): Nullable<T> {
    return isEmpty(value) ? null : value
}
